export default function ErrorMsg({ message, className }: { message: string, className?: string }) {
  return <p className={`text-red-400 text-sm mt-2 ${className}`}>{message}</p>;
}
